import classnames from 'classnames';
import { ProductSummaryBlockDefinition } from 'components/common-form/sidePanel/docToolbar/summary/builder/model';
import { useSgBsTheme } from 'hooks/useSgBsTheme';
import { ReadonlyValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC, PropsWithChildren } from 'react';
import type { BatchWorkspaceVersion, QuoteWorkspaceVersion } from 'state/userPreferences/userPreferences.model';

import { useFieldNotInThisVersion } from '../../hooks';
import { ProductSummaryNode } from '../../ProductSummaryBuilder';

interface ProductSummaryFieldsListProps {
  nodes?: ReadonlyArray<ProductSummaryBlockDefinition | ReadonlyValueDefinition>;
  level: number;
  tabId: string;
  quoteWorkspaceVersion: QuoteWorkspaceVersion;
  batchWorkspaceVersion: BatchWorkspaceVersion;
  mustForceAdvancedMode: boolean;
}

export const ItemWrapper: FC<
  PropsWithChildren<{
    node: ProductSummaryBlockDefinition | ReadonlyValueDefinition;
    quoteWorkspaceVersion: QuoteWorkspaceVersion;
    isDarkMode: boolean;
    mustForceAdvancedMode: boolean;
  }>
> = ({ children, node, isDarkMode, quoteWorkspaceVersion, mustForceAdvancedMode }) => {
  const isHidden = node.isHidden;
  const isNotInThisVersion = useFieldNotInThisVersion(node, quoteWorkspaceVersion, mustForceAdvancedMode);
  if (isHidden || isNotInThisVersion) {
    return null;
  }
  return (
    <th
      className={classnames('list-group-item py-2', {
        'border-dark': isDarkMode,
        'border-light': !isDarkMode,
      })}
    >
      {children}
    </th>
  );
};
export function ProductSummaryFieldsList({
  nodes,
  tabId,
  level,
  quoteWorkspaceVersion,
  batchWorkspaceVersion,
  mustForceAdvancedMode,
}: ProductSummaryFieldsListProps) {
  const isDarkMode = useSgBsTheme() === 'dark';
  if (nodes === undefined) {
    return null;
  }
  if (nodes) {
    return (
      <tr className="list-group list-group-flush">
        {nodes.map(subChild => (
          <ItemWrapper
            key={subChild.id}
            node={subChild}
            isDarkMode={isDarkMode}
            quoteWorkspaceVersion={quoteWorkspaceVersion}
            mustForceAdvancedMode={mustForceAdvancedMode}
          >
            <ProductSummaryNode
              tabId={tabId}
              node={subChild}
              level={level + 1}
              quoteWorkspaceVersion={quoteWorkspaceVersion}
              batchWorkspaceVersion={batchWorkspaceVersion}
              mustForceAdvancedMode={mustForceAdvancedMode}
            />
          </ItemWrapper>
        ))}
      </tr>
    );
  }
  return null;
}

ProductSummaryFieldsList.displayName = 'ProductSummaryFieldsList';
